const PHONE_CODE = "+213";
const NUMBERS_LIMIT = 9;
const MOBILE_STARS = "xxxxxxxxx";
const MAPS_COUNTRY = "dz";

const ALL = "All";
const DELIVERY = "Delivery";
const PICKUP = "Pickup";

const COUNTRY_NAME = process.env.REACT_APP_COUNTRY_NAME;

export {
  PHONE_CODE,
  NUMBERS_LIMIT,
  MOBILE_STARS,
  ALL,
  DELIVERY,
  PICKUP,
  MAPS_COUNTRY,
  COUNTRY_NAME,
};
